import React from 'react';
import { get, isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import * as backRoute from 'utils/backRoute';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberPrescriptionDetail as MemberPrescriptionDetailView } from 'ui/views/widgets/memberPrescriptionDetail';
import { MemberPrescriptionDetailService } from 'services/memberPrescriptionDetail';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberPrescriptionDetail } from 'ui/containers/MemberPrescriptionDetail';
 *
 * // render
 * <MemberPrescriptionDetail propName='propValue'/>
 */
class _MemberPrescriptionDetail extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind
        this.handleNavActionClick = this.handleNavActionClick.bind( this );

        // check if URL container `memberId` query parameter.
        const queryParams = queryString.parse( this.props.location.search );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            rxId: get( queryParams, 'rxId' ),
            memberId: get( this.props.location, 'state.memberId', undefined ),
            patientId: get( this.props.location, 'state.patientId', undefined ),
        };

        // Member Detail instance
        this.memberPrescriptionDetailService = new MemberPrescriptionDetailService();
        //previously memberId is empty changed to patitent IdisEmpty( this.state.memberId )
        if( isEmpty( this.state.patientId ) || isEmpty( this.state.rxId ) ) {

            return this.props.history.goBack();
            
        }

        // start member detail data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch member detail information.
     */
    async fetchComponentData() {
        log.debug( 'MemberPrescriptionDetail.memberDetailsEntitiesWidgetService()' );

        // cancel ongoing request
        this.memberPrescriptionDetailService.cancel();

        try {
            const { status, data }  = await this.memberPrescriptionDetailService.fetchData( {
                url: this.props.widget.url,
                data: {
                    context: {
                        rxId: this.state.rxId,
                        memberId: this.state.memberId,
                        patientId: this.state.patientId,
                    
                    }
                }
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    handleNavActionClick( { type, value } ) {
        log.debug( 'MemberOrderDetail.handleNavActionClick()' );

        if(  'headerAction' === type && 'back' === value.name ) {

            // get back-route payload
            const backRoutePayload = backRoute.decode( this.props.location );

            if( ! isEmpty( backRoutePayload ) ) {
                return this.props.history.push( backRoutePayload );
            }

            // go to back
            this.props.history.goBack();
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberPrescriptionDetailService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberPrescriptionDetailView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onNavActionClick={ this.handleNavActionClick }
                requestPayload={ {
                    context: {
                        memberId: this.state.memberId,
                        patientId: this.state.patientId,
                        rxId: this.state.rxId
                    }
                } }
            />
        );
    }
}

// set display name
_MemberPrescriptionDetail.displayName = 'MemberPrescriptionDetail';

// set default props
_MemberPrescriptionDetail.defaultProps = {};

// prop types
_MemberPrescriptionDetail.propTypes = {};

export const MemberPrescriptionDetail = withRouter( _MemberPrescriptionDetail );
